module.exports = __webpack_public_path__ + "static/media/infoIcon.c0e38092.svg";